var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.9917C12.8985 14.9917 14.4375 13.4527 14.4375 11.5542C14.4375 9.65572 12.8985 8.1167 11 8.1167C9.10152 8.1167 7.5625 9.65572 7.5625 11.5542C7.5625 13.4527 9.10152 14.9917 11 14.9917Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5607 15.8586C3.18084 15.2043 2.88981 14.5024 2.69531 13.7712L4.13734 11.9665C4.12102 11.6906 4.12102 11.414 4.13734 11.1381L2.69617 9.3334C2.89034 8.60214 3.18077 7.8999 3.55984 7.24512L5.85523 6.9873C6.03853 6.78079 6.23396 6.58537 6.44047 6.40207L6.69828 4.10754C7.35213 3.73027 8.05321 3.44157 8.78312 3.24902L10.5878 4.69105C10.8637 4.67473 11.1403 4.67473 11.4162 4.69105L13.2209 3.24988C13.9522 3.44405 14.6544 3.73448 15.3092 4.11355L15.567 6.40895C15.7735 6.59224 15.969 6.78767 16.1523 6.99418L18.4468 7.25199C18.8267 7.90629 19.1177 8.60827 19.3122 9.33941L17.8702 11.1441C17.8865 11.42 17.8865 11.6966 17.8702 11.9725L19.3113 13.7772C19.1185 14.5083 18.8295 15.2105 18.452 15.8655L16.1566 16.1233C15.9733 16.3298 15.7778 16.5253 15.5713 16.7086L15.3135 19.0031C14.6592 19.383 13.9572 19.674 13.2261 19.8685L11.4214 18.4264C11.1455 18.4428 10.8689 18.4428 10.593 18.4264L8.78828 19.8676C8.05723 19.6748 7.35501 19.3858 6.7 19.0082L6.44219 16.7129C6.23567 16.5296 6.04025 16.3341 5.85695 16.1276L3.5607 15.8586Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarGear);
export default __webpack_public_path__ + "static/media/icon-sidebar-gear.0f9b39a663261094c83d0e8294859e88.svg";
export { ForwardRef as ReactComponent };